import {
    apiRequest,
    PengaturanMenuUpdate,
    PengaturanMenuDetail,
    PengaturanMenuParentList
} from "../../../../../services/adapters/kepegawaian/menuService"

class UpdateRepository {
    fetchUpdate = async (query) => {
        return await apiRequest("post", PengaturanMenuUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", PengaturanMenuDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default UpdateRepository